import React from "react";

const MagneticButton = ({ children, onClick }) => {
  return (
    <button onClick={onClick} className="magnetic-btn">
      {children}
    </button>
  );
};

export default MagneticButton;
